import { render, staticRenderFns } from "./TaxStrategyPicker.vue?vue&type=template&id=ee20f08e&"
import script from "./TaxStrategyPicker.vue?vue&type=script&lang=ts&"
export * from "./TaxStrategyPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports